export default "__VITE_ASSET__a4b2d14e__"